import React, { useMemo } from 'react'
import {
  CANCEL_BUTTON_TX,
  ADD_USER_TX_BUTTON,
  ADD_USERS_TX_BUTTON,
} from './constants'
import AddUserModalInputText from '../InputText'
import AddUserModalSendNotification from '../SendNotification'
import AddUserModalSelectRole from '../SelectRole'
import {
  AddMultipleUsersButton,
  AddSingleUserButton,
  ButtonsContainer,
  CancelButton,
  LeftWrapper,
  MainWrapper,
  RightWrapper,
} from './AddUserModalForm.styles'
import { inputModeType } from 'lib/util'
import { RoleInfo, FormValues, FormErrors } from './types'

interface AddUserModalFormProps {
  errors: FormErrors
  handleCloseModal: () => void
  handleInputModeToggle: () => void
  inputMode: string
  isSubmitting: boolean
  rolesInfo: RoleInfo[]
  setSubmitClicked: (value: boolean) => void
  values: FormValues
}

const AddUserModalForm: React.FC<AddUserModalFormProps> = ({
  errors,
  handleCloseModal,
  handleInputModeToggle,
  inputMode,
  isSubmitting,
  rolesInfo,
  setSubmitClicked,
  values,
}) => {
  const isSingleMode = inputMode === inputModeType.single

  const { buttonText, ButtonComponent } = useMemo(
    () => ({
      buttonText: isSingleMode ? ADD_USER_TX_BUTTON : ADD_USERS_TX_BUTTON,
      ButtonComponent: isSingleMode
        ? AddSingleUserButton
        : AddMultipleUsersButton,
    }),
    [isSingleMode],
  )

  return (
    <MainWrapper>
      <LeftWrapper>
        <AddUserModalInputText
          errors={errors}
          handleInputModeToggle={handleInputModeToggle}
          inputMode={inputMode}
          values={values}
        />
        <AddUserModalSendNotification inputMode={inputMode} values={values} />
      </LeftWrapper>
      <RightWrapper>
        <AddUserModalSelectRole
          inputMode={inputMode}
          rolesInfo={rolesInfo}
          values={values}
        />
        <ButtonsContainer>
          <CancelButton
            dataTestId="modal-form-cancel-button"
            onClick={handleCloseModal}
          >
            {CANCEL_BUTTON_TX}
          </CancelButton>
          <ButtonComponent
            dataTestId="modal-form-add-user-button"
            disabled={isSubmitting}
            onClick={() => setSubmitClicked(true)}
            type="submit"
          >
            {buttonText}
          </ButtonComponent>
        </ButtonsContainer>
      </RightWrapper>
    </MainWrapper>
  )
}

export default AddUserModalForm
